/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Contract_Plan_TitleInputs */



/**
* | output |
* | --- |
* | "Your plan is set by your contract" |
*
* @param {Sub_Contract_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_contract_plan_title = /** @type {((inputs?: Sub_Contract_Plan_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Contract_Plan_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Tarif ist vertraglich festgelegt")
	return /** @type {LocalizedString} */ ("Your plan is set by your contract")
});